import { Injectable, Inject } from '@angular/core';

import { WINDOW_TOKEN } from '../bootstrap.service';
import { BrowserWindow } from './init-webview.service';

export type EasytradeNativePageId = 'navigateToQuote' |
                                    'navigateToOrderEntry' |
                                    'navigateToCashTransfer' |
                                    'navigateToTransferLanding' |
                                    'navigateToExploreLanding';

@Injectable({
  providedIn: 'root'
})
export class EasytradeNativeService {

  isNativeActive: boolean = false;

  constructor(@Inject(WINDOW_TOKEN) private window: Partial<BrowserWindow>) { }

  /**
    Android puts isERT and navigateToNativeEasyTrade under window.ugobridge
    iOS exposes isERT and navigateToNativeEasyTrade just under window
  **/
  init(): void {
    if(this.window?.ugobridge?.isETR !== undefined && this.window.ugobridge.isETR()) {
      this.isNativeActive = true;
    } else if (this.window?.isETR !== undefined && this.window.isETR()) {
      this.isNativeActive = true;
    }
  }

  navigateToNative(pageId: EasytradeNativePageId, params?: { [key: string]: string }): void {
    const navigationParam: string = JSON.stringify({
      navigateAction: pageId,
      ...(params && { params })
    });

    if (this.window?.ugobridge?.navigateToNativeEasyTrade !== undefined) {
      this.window.ugobridge.navigateToNativeEasyTrade(navigationParam);
    } else if (this.window?.navigateToNativeEasyTrade !== undefined) {
      this.window.navigateToNativeEasyTrade(navigationParam);
    }
  }
}
